import * as React from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { Link } from 'react-router-dom';

import { usePasswordRecovery } from '../data/usePasswordRecovery';
import { useRecaptcha } from '../data/useRecaptcha';

export const ForgotPassword = () => {
  const [email, setEmail] = React.useState('');
  const [emailValid, setEmailValid] = React.useState(true);
  const [submitted, setSubmitted] = React.useState(false);

  const recoveryMutation = usePasswordRecovery();
  const { executeRecaptcha } = useRecaptcha();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const valid = email && email.length > 0;
    setEmailValid(!!valid);

    if (!valid) {
      return;
    }

    const token = await executeRecaptcha('password_recovery');
    recoveryMutation.mutate(
      { email, recaptcha_response: token },
      {
        onSettled: () => {
          setSubmitted(true);
        },
      },
    );
  };

  return (
    <div
      style={{
        background: 'linear-gradient(#74C9E6, #3174AB)',
        backgroundSize: 'cover',
        height: '100%',
        minHeight: '100vh',
        display: 'block',
        paddingBottom: '1em',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          padding: '1em',
        }}
      >
        <img
          src="assets/images/aquifer-logo-rgb.svg"
          alt="Aquifer"
          style={{
            margin: '0 auto',
            display: 'block',
            width: '255px',
          }}
        />
      </div>

      <div
        style={{
          textAlign: 'center',
          color: '#ffffff',
          fontSize: '3em',
          margin: '1.25em 0',
        }}
      >
        Password Recovery
      </div>

      <Card
        style={{
          width: '250px',
          position: 'relative',
          margin: '0 auto',
          padding: '2em 3.5em',
        }}
      >
        <Backdrop
          sx={{
            background: 'rgba(255, 255, 255, 0.5)',
            position: 'absolute',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={recoveryMutation.isPending}
        >
          <CircularProgress />
        </Backdrop>
        <Stack spacing={2}>
          <div
            style={{
              fontFamily: 'Noto Sans',
              fontSize: '24px',
              lineHeight: '30px',
              textAlign: 'center',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            Reset Password
          </div>

          {submitted ? (
            <Alert severity="success" data-cy="success-message">
              If an account exists with that email, you will receive password
              reset instructions shortly.
            </Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  data-cy="email"
                  label="Email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!emailValid}
                  helperText={!emailValid ? 'Email Required' : ''}
                />

                <Button
                  data-cy="submit-button"
                  type="submit"
                  variant="contained"
                >
                  Send Reset Link
                </Button>
              </Stack>
            </form>
          )}

          <Link
            to="/login"
            style={{
              textAlign: 'center',
              color: '#3174AB',
              textDecoration: 'none',
              fontSize: '14px',
            }}
            data-cy="back-to-login"
          >
            Back to Login
          </Link>
        </Stack>
      </Card>
      <div
        style={{
          width: 360,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: '0 auto',
          padding: '1em',
          color: '#fff',
        }}
      >
        <div style={{ display: 'flex' }}>
          <Link style={{ color: '#fff' }} to="/privacy-policy">
            Privacy Policy
          </Link>
          <span style={{ margin: '0 0.5em' }}>|</span>
          <Link style={{ color: '#fff' }} to="/terms-of-service">
            Terms of Service
          </Link>
        </div>
        <small
          style={{
            marginTop: '0.5em',
            fontSize: '11px',
            opacity: 0.8,
            textAlign: 'center',
          }}
        >
          This site is protected by reCAPTCHA and the Google{' '}
          <a
            href="https://policies.google.com/privacy"
            style={{ color: '#fff' }}
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="https://policies.google.com/terms" style={{ color: '#fff' }}>
            Terms of Service
          </a>{' '}
          apply.
        </small>
      </div>
    </div>
  );
};
